import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { ConfigService } from '../config.service';
import { MissionControlHostService } from '../mission-control-host.service';

import { ActivatedRoute, Router } from '@angular/router';



@Component({
    selector: 'app-mc-cf-login',
    templateUrl: './mc-cf-login.component.html',
    styleUrl: './mc-cf-login.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class McCfLoginComponent implements OnInit {

  //Block to only tested routes until ready for app wide usage
  readonly allowedRoutes: string[] = ['/trip-staffing']

  visible = signal<boolean>(false)

  isProduction = this.configService.isProduction

constructor(
  private configService: ConfigService,
  private mcService: MissionControlHostService,
  private route: ActivatedRoute,
  private router: Router

) {

  
}
  

ngOnInit(): void {

  
  this.mcService.mcNotAuthorizedFailure$.subscribe((value) => {
    console.log(this.router.url)
    if (this.allowedRoutes.includes(this.router.url)) 
    this.visible.set(value)
  })
  }

  onIframeLoad(event: any) {
    console.log(event)
  }

}
